var $ = require('jQuery');
var _ = require('underscore');
var Uploader = require('uploader');

module.exports = function() {

    if (typeof standaloneOptions !== 'undefined') {
        $.each(standaloneOptions, function (i, uploader) {
            var element = $('#'+uploader.id);

            if (element.length > 0) {
                new Uploader(uploader.options.clarify(), element);
            }
        });
    }

};
